import { createSlice } from "@reduxjs/toolkit";

interface qrScannerState {
    qrCode: string;
    qrScannerStatus: "idle" | "pending" | "succeeded" | "failed";
};

const initialState = {
    qrCode: "",
    qrScannerStatus: "idle",
} as qrScannerState;


const qrScannerSlice = createSlice({
  name: "qrScanner",
  initialState,
  reducers: {
    setInitialData() {
      return initialState;
    },
    setQRCode(state, { payload }) {
      state.qrCode = payload;
    },
    setQRScannerStatus(state, { payload }) {
      state.qrScannerStatus = payload;
    },

  },
  extraReducers: (builder) => {},
});

export const {
  setInitialData,
  setQRCode,
  setQRScannerStatus,
} = qrScannerSlice.actions

export default qrScannerSlice.reducer